import { TFunction } from 'i18next';

import { ExpiringCredential } from '@Models';

const getTag = (connector: string): string => {
  if (['wrl', 'gs1_wrl'].includes(connector)) {
    return 'walmart';
  }
  return connector;
};

export type ExpiringCounts = {
  expiredCount: number;
  expiringCount: number;
};

const getExpiringCredentialsCounts = (creds?: ExpiringCredential[] | null): ExpiringCounts => {
  const list = creds ?? [];
  const expiredCount = list.reduce((acc, c) => {
    const status = String((c as any)?.status ?? '').toUpperCase();
    return acc + (status === 'EXPIRED' || status === 'EXPIRADO' || status === 'VENCIDO' ? 1 : 0);
  }, 0);
  const expiringCount = list.length - expiredCount;
  return { expiredCount, expiringCount };
};

const getCredentialExpiringExpiredMessage = (t: TFunction, creds?: ExpiringCredential[] | null): string => {
  const list = creds ?? [];
  if (list.length === 0) return '';
  const { expiredCount, expiringCount } = getExpiringCredentialsCounts(list);
  if (expiredCount > 0 && expiringCount > 0) {
    return t('Credentials.ExpiredAndExpiring', { expired: expiredCount, expiring: expiringCount });
  }
  if (expiredCount > 0) {
    return `${expiredCount} ${t('Credentials.ExpiredCount')}`;
  }
  return `${expiringCount} ${t('Credentials.ExpiringSoon')}`;
};

/* eslint import/prefer-default-export: "off" */
export { getCredentialExpiringExpiredMessage, getExpiringCredentialsCounts, getTag };
